// duzenleyen.js — DÜZENLEMEYİ KİM YAPTI? TEK KAYNAK (2 Eki 2026)
//
// 🔑 Serkan (2 Eki 2026, ofis talebi): "edit report'ta kim yaptı yazsın … kim edit yaptıysa o kullanıcının kullanıcı
//    adı da görünsün" → "sadece ekip kodu görünsün, fazla alan işgal etmeyelim".
// 🔴 ÖNCESİ (ölçüldü): düzenleyen kayıtta vardı (ftl_duty_edits / admin_edits.edited_by · superadmin_log.actor_id)
//    ama üç ekranın hiçbiri göstermiyordu; ikisi alanı sorguda okumuyordu bile.
// Boş düzenleyen = sistemin kendisi (iPad arşivi, otomatik OFF → REST, tek seferlik düzeltmeler) → SYSTEM.
// GO2 süper admin satırı → "GO2" (kodu görülebiliyorsa "GO2 XXX"). Listede olmayan kimlik → UNKNOWN (uydurulmaz).

/** profiller: [{ id, code }] — şirketin kullanıcıları (süper admin hepsini görür). */
export function duzenleyenKodu(id, profiller, { go2 = false } = {}) {
  const p = id ? (profiller || []).find(x => x.id === id) : null;
  const kod = p ? (p.code || 'NO CODE') : null;
  if (go2) return kod ? `GO2 ${kod}` : 'GO2';
  if (!id) return 'SYSTEM';
  return kod || 'UNKNOWN';
}
